import React, { useEffect, useState } from 'react';
import update from 'immutability-helper';
import { enqueueSnackbar } from 'notistack';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

import theme from '@/constants/theme';
import Button from '@/components/input/Button';
import ReorderContentCard from './ReorderContentCard';
import { contentsService } from '@/services/contents';
import { Content } from '@/services/contents/content.vm';

interface Props {
  routeId?: string;
  contents: Content[];
  setIsOrdering: React.Dispatch<React.SetStateAction<boolean>>;
  handleReload: () => void;
}

const ReorderingContents: React.FC<Props> = ({ routeId, contents, setIsOrdering, handleReload }) => {
  const [contentsOrder, setContentsOrder] = useState(contents);

  const moveContent = (fromIndex: number, toIndex: number) => {
    setContentsOrder((prev) => {
      return update(prev, {
        $splice: [
          [fromIndex, 1],
          [toIndex, 0, prev[fromIndex]],
        ],
      });
    });
  };

  const handleSaveOrder = () => {
    const formatedResponse = contentsOrder.map((route, index) => ({
      contentId: route.id,
      newOrder: index + 1,
    }));
    contentsService.reorder(formatedResponse).then((result) => {
      handleReload();
      enqueueSnackbar({
        message: 'Orden guardada correctamente',
        variant: 'success',
      });
    });
  };

  useEffect(() => {
    setContentsOrder(contents);
  }, [contents]);

  return (
    <DndProvider backend={HTML5Backend}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 16,
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h2 style={{ color: theme.colors.text.title }}>Reordenar Contenidos</h2>
          <div style={{ display: 'flex', gap: 16 }}>
            <Button variant="danger" onClick={() => setIsOrdering(false)}>
              Cancelar
            </Button>
            <Button onClick={handleSaveOrder}>Guardar Orden</Button>
          </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          {contentsOrder.map((content, index) => (
            <ReorderContentCard key={content.id} content={content} index={index} moveContent={moveContent} />
          ))}
        </div>
      </div>
    </DndProvider>
  );
};

export default ReorderingContents;
